import React, { PureComponent } from "react";

import styles from "./style.module.css";

export default class MadlibsObjective extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { editMode, children, itemNumber, itemContent } = this.props;

    return (
      <div className={styles.madlibsText}>
        <div className={styles.madlibsItem + " " + (editMode ? styles.isEdit : "")}>
          <div className={styles.madlibsItemNumber}>{itemNumber + "."}</div>
          <div className={styles.madlibsItemContent}>{itemContent}</div>
        </div>
        {editMode ? <div className={styles.madlibsItemInputsWrapper}>{children}</div> : <React.Fragment />}
      </div>
    );
  }
}
